import { useState } from "react";
import emailjs from "emailjs-com";

const initialState = {
  name: "",
  email: "",
  message: "",
};
export const Contact = (props) => {
  const [{ name, email, message }, setState] = useState(initialState);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };
  const clearState = () => setState({ ...initialState });
  
  
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(name, email, message);
    
    emailjs
      .sendForm("service_x6soq3h", "template_27jad59", e.target, "7ksYm5RpIyE-H-3g8")
      .then(
        (result) => {
          console.log(result.text);
          clearState();
        },
        (error) => {
          console.log(error.text);
        }
      );
  };
  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="row">
                <div className="section-title">
                  <h2>Get In Touch</h2>
                  <p>
                    Please fill out the form below to send us an email and we will
                    get back to you as soon as possible.
                  </p>
                </div>
                <form name="sentMessage" onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <input
                          type="text"
                          id="name"
                          name="name"
                          className="form-control"
                          placeholder="Name"
                          required
                          value={name}
                          onChange={handleChange}
                        />
                        <p className="help-block text-danger"></p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <input
                          type="email"
                          id="email"
                          name="email"
                          className="form-control"
                          placeholder="Email"
                          required
                          value={email}
                          onChange={handleChange}
                        />
                        <p className="help-block text-danger"></p>
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <textarea
                      name="message"
                      id="message"
                      className="form-control"
                      rows="4"
                      placeholder="Message"
                      required
                      value={message}
                      onChange={handleChange}
                    ></textarea>
                    <p className="help-block text-danger"></p>
                  </div>
                  <div id="success"></div>
                  <button type="submit" className="btn btn-custom btn-lg">
                    Send Message
                  </button>
                </form>
              </div>
            </div>

            <div className="col-md-3">
              <div className="contact-item">
                <h3>Contact Info</h3>
                <p>
                  <span><strong><i className="fa-solid fa-location-dot"></i> Address</strong></span>
                  {props.data ? props.data.address : "loading"}
                </p>
              </div>
              <div className="contact-item">
                <p>
                  <span><strong><i className="fa-solid fa-phone"></i> Phone</strong></span> 
                  {props.data ? props.data.phone : "loading"}
                </p>
              </div>
              <div className="contact-item">
                <p>
                  <span><strong><i className="fa-solid fa-envelope"></i> Email</strong></span> 
                  {props.data ? props.data.email : "loading"}
                </p>
              </div>
            </div>

              <div className="contact-item">
                <h3>Business Hours</h3>
                <p><strong>Monday:</strong> 10:00 AM - 5:00 PM</p>
                <p><strong>Tuesday:</strong> 10:00 AM - 5:00 PM</p>
                <p><strong>Wednesday:</strong> 10:00 AM - 5:00 PM</p>
                <p><strong>Thursday:</strong> 10:00 AM - 5:00 PM</p>
                <p><strong>Friday:</strong> 10:00 AM - 5:00 PM</p>
                <p><strong>Saturday:</strong> 10:00 AM - 5:00 PM</p>
                <p><strong>Sunday:</strong> 10:00 AM - 5:00 PM</p>
              </div>
          </div>
        </div>
      </div>
      <div>
        <div id="footer">
          <div className="container text-center">
            <p>
              &copy; 2026 Thai & Leach CPA LLP. All rights reserved
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
